import { render, staticRenderFns } from "./deleteBorrow.vue?vue&type=template&id=46262f3f"
import script from "./deleteBorrow.vue?vue&type=script&lang=js"
export * from "./deleteBorrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports